import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { StageTaskType } from "@/store/Lifecycle/constants";
import { LifecycleStoreTask } from "@/store/Lifecycle/types";
import TaskRow from "../../../taskComponents/TaskRow";
import { LinkField } from "../../../taskComponents/LinkField";
import { TextField } from "../../../taskComponents/TextField";
import { EnumField } from "../../../taskComponents/EnumField";
import { BooleanField } from "../../../taskComponents/BooleanField";
import { DateRangeField } from "../../../taskComponents/DateRangeField";
import { DateField } from "../../../taskComponents/DateField";
import { UnitsField } from "../../../taskComponents/UnitsField";
import { TaskProvider } from "../../../taskComponents/Provider";
import { getTaskSectionMetadata } from "../../../taskComponents/constants";
import { PercentageField } from "../../../taskComponents/PercentageField";
import { MeasurementUnitField } from "../../../taskComponents/MeasurementUnitField";

interface TasksRowProps {
    name: string;
    tasks: LifecycleStoreTask<StageTaskType>[];
}

export const TasksRow = ({ name, tasks }: TasksRowProps) => {
    const { t } = useTranslation();
    const { icon, title, subtitle, tooltip } = getTaskSectionMetadata(name);

    const renderTask = useCallback((task: LifecycleStoreTask<StageTaskType>) => {
        switch (task.type) {
            case StageTaskType.Text:
                return <TextField/>;
            case StageTaskType.Enum:
                return <EnumField/>;
            case StageTaskType.Link:
                return <LinkField/>;
            case StageTaskType.Boolean:
                return <BooleanField/>;
            case StageTaskType.Date:
                return <DateField/>;
            case StageTaskType.DateRange:
                return <DateRangeField/>;
            case StageTaskType.Units:
                return <UnitsField />
            case StageTaskType.Percentage:
                return <PercentageField/>;
            case StageTaskType.MeasurementUnit:
                return <MeasurementUnitField/>;
        }
    }, []);

    return (
        <TaskRow icon={icon} title={t(title)} subtitle={t(subtitle)} tooltip={t(tooltip)}>
            {tasks.map((task, index) => (
                <TaskProvider key={index} task={task}>
                    {renderTask(task)}                 
                </TaskProvider>
            ))}
        </TaskRow>
    );
};